import * as React from "react";
import { useNavigate } from "react-router-dom";

interface NavItemProps {
  text: string;
  isButton?: boolean;
  onClick?: () => void;
}

interface HeaderProps {
  showCredits?: boolean;
  credits?: number;
}

const NavItem: React.FC<NavItemProps> = ({ text, isButton, onClick }) => {
  const baseClasses = "self-stretch my-auto";
  const buttonClasses =
    "px-9 py-4 text-center whitespace-nowrap rounded-xl border border-solid border-zinc-900 max-md:px-5 bg-base hover:bg-upload-button-hover active:bg-upload-button-pressed";

  return (
    <button
      className={`${baseClasses} ${isButton ? buttonClasses : ""}`}
      onClick={onClick}
    >
      {text}
    </button>
  );
};

export const Header: React.FC<HeaderProps> = ({ showCredits = false, credits }) => {
  const navigate = useNavigate();
  const handleLogoClick = () => {
    console.log("Logo clicked");
    // When clicked, the user will be redirected to the prompt.tsx page
    navigate('/prompt');
  };

  const handleNavItemClick = (text: string) => {
    console.log(`${text} clicked`);
    // Add your nav item click logic here
  };

  const navItems = [
    { text: "About us", onClick: () => handleNavItemClick("About us") },
    { text: "Services", onClick: () => handleNavItemClick("Services") },
    { text: "Account", isButton: true, onClick: () => handleNavItemClick("Account") },
  ];

  return (
    <div className="flex overflow-hidden flex-wrap justify-between items-center px-8 w-full bg-white min-h-[80px] max-md:px-10 max-md:max-w-full z-10">
      <div
        className="flex overflow-hidden gap-2.5 items-start self-stretch py-2.5 my-auto bg-white w-[195px] cursor-pointer"
        onClick={handleLogoClick}
      >
        <img
          loading="lazy"
          src = "./logo.svg"
          alt="Logo"
          className="object-contain aspect-[3.25] w-[195px]"
        />
      </div>
      <div className="flex gap-10 justify-center items-center self-stretch my-auto text leading-snug text-black min-w-[240px] font-space-grotesk">
        {showCredits && (
          <div className="flex items-center mr-4">
            <span className="text-sm font-bold">Credits: <span className="text-sm font-bold">{credits ?? 0}</span></span>
          </div>
        )}
        {navItems.map((item, index) => (
          <NavItem key={index} {...item} />
        ))}
      </div>
    </div>
  );
};
